"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactComponents = require("@cimpress/react-components");

var _fuse = _interopRequireDefault(require("fuse.js"));

var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));

var _reactIntl = require("react-intl");

var _withI18n = _interopRequireDefault(require("../../i18n/withI18n"));

var _SkuUploadModal = _interopRequireDefault(require("./SkuUploadModal"));

var _SkuCard = _interopRequireWildcard(require("../SkuCard/SkuCard"));

var _SkuCardVirtualizedList = _interopRequireDefault(require("../SkuCard/SkuCardVirtualizedList"));

var _LinkDropdown = _interopRequireDefault(require("../LinkDropdown"));

var _skuSelectorMessages = require("../skuSelectorMessages");

var _CsvLinkDownload = _interopRequireDefault(require("../CsvLinkDownload"));

var SelectedSkuBin =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(SelectedSkuBin, _PureComponent);

  function SelectedSkuBin() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, SelectedSkuBin);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(SelectedSkuBin)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      showRemoveModal: false,
      fuse: null,
      filter: '',
      filteredSkuInfoList: [],
      filterBySku: true,
      filterByName: true,
      filterByDescription: true
    };

    _this.onChangeFilterOption = function (option) {
      _this.setState((0, _defineProperty2.default)({}, option, !_this.state[option]));
    };

    _this.onChangeFilter = function (event) {
      _this.setState({
        filter: event.target.value
      });
    };

    _this.openRemoveSkusModal = function () {
      _this.setState({
        showRemoveModal: true
      });
    };

    _this.closeRemoveSkusModal = function () {
      _this.setState({
        showRemoveModal: false
      });
    };

    _this.skuCardRenderer = function (skuInfo) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          hasAction = _this$props.hasAction,
          actionIcon = _this$props.actionIcon,
          onAction = _this$props.onAction,
          draggable = _this$props.draggable,
          checkable = _this$props.checkable,
          isSkuChecked = _this$props.isSkuChecked,
          onChangeChecked = _this$props.onChangeChecked,
          clickable = _this$props.clickable,
          isSkuClicked = _this$props.isSkuClicked,
          unactionableSkuList = _this$props.unactionableSkuList,
          unactionableTooltipMessage = _this$props.unactionableTooltipMessage,
          skuCardCustomRenderFn = _this$props.skuCardCustomRenderFn;
      return skuCardCustomRenderFn ? skuCardCustomRenderFn({
        skuInfo: skuInfo,
        disabled: disabled,
        hasAction: hasAction,
        actionIcon: actionIcon,
        onAction: onAction,
        draggable: draggable,
        checkable: checkable,
        isSkuChecked: isSkuChecked,
        onChangeChecked: onChangeChecked,
        clickable: clickable,
        isSkuClicked: isSkuClicked,
        unactionableSkuList: unactionableSkuList,
        unactionableTooltipMessage: unactionableTooltipMessage
      }) : _react.default.createElement(_SkuCard.default, {
        className: "selected-sku-bin__content-sku-card",
        skuInfo: skuInfo,
        hasAction: hasAction,
        actionIcon: actionIcon,
        onAction: onAction,
        draggable: draggable,
        checkable: checkable,
        isChecked: isSkuChecked && isSkuChecked(skuInfo.sku),
        onChangeChecked: onChangeChecked,
        clickable: clickable,
        isClicked: isSkuClicked && isSkuClicked(skuInfo.sku),
        disabled: disabled || unactionableSkuList && unactionableSkuList.includes(skuInfo.sku),
        disabledTooltipMsg: unactionableTooltipMessage
      });
    };

    return _this;
  }

  (0, _createClass2.default)(SelectedSkuBin, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var skus = this.props.skus;
      var _this$state = this.state,
          filter = _this$state.filter,
          fuse = _this$state.fuse,
          filterBySku = _this$state.filterBySku,
          filterByName = _this$state.filterByName,
          filterByDescription = _this$state.filterByDescription;
      var filterChanged = filterBySku !== prevState.filterBySku || filterByName !== prevState.filterByName || filterByDescription !== prevState.filterByDescription;

      if (!fuse || skus !== prevProps.skus || filterChanged) {
        if (!skus) return;
        var skuInfoObjects = Object.values(skus);
        var filterOptions = [];
        filterBySku && filterOptions.push('sku');
        filterByName && filterOptions.push('name');
        filterByDescription && filterOptions.push('description');
        var isOnlySkuFilterSelected = filterBySku && !filterByName && !filterByDescription;
        var options = {
          shouldSort: true,
          threshold: isOnlySkuFilterSelected ? 0 : 0.6,
          location: 0,
          distance: 100,
          maxPatternLength: 32,
          minMatchCharLength: 1,
          keys: filterOptions
        };
        var newFuse = new _fuse.default(skuInfoObjects, options);
        var filteredSkuInfoList = newFuse.search(filter);
        this.setState({
          filteredSkuInfoList: filteredSkuInfoList,
          fuse: newFuse
        });
        return;
      }

      if (skus === prevProps.skus && filter !== prevState.filter) {
        var _filteredSkuInfoList = fuse.search(filter);

        this.setState({
          filteredSkuInfoList: _filteredSkuInfoList
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          skus = _this$props2.skus,
          className = _this$props2.className,
          bulkRemoveSkus = _this$props2.bulkRemoveSkus,
          disabled = _this$props2.disabled,
          showCsvDownload = _this$props2.showCsvDownload,
          showFilter = _this$props2.showFilter,
          style = _this$props2.style,
          generateCsvRowsOverride = _this$props2.generateCsvRowsOverride,
          customBulkErrorMessage = _this$props2.customBulkErrorMessage,
          formatMessage = _this$props2.intl.formatMessage,
          customSkuCardVirtualizedListProps = _this$props2.customSkuCardVirtualizedListProps;
      var _this$state2 = this.state,
          filter = _this$state2.filter,
          filteredSkuInfoList = _this$state2.filteredSkuInfoList,
          filterBySku = _this$state2.filterBySku,
          filterByDescription = _this$state2.filterByDescription,
          filterByName = _this$state2.filterByName;
      var skuInfoList = skus ? Object.values(skus) : [];
      var filterExists = filter && filter.trim() !== '';
      var dataExists = !filterExists && skuInfoList && skuInfoList.length || filterExists && filteredSkuInfoList && filteredSkuInfoList.length;

      var skuCardList = _react.default.createElement(_SkuCardVirtualizedList.default, Object.assign({
        skuCardList: filterExists ? filteredSkuInfoList : skuInfoList,
        skuCardRenderer: this.skuCardRenderer
      }, customSkuCardVirtualizedListProps));

      var contentClassName = "selected-sku-bin__content".concat(dataExists ? '' : '--empty');
      var noFilterResult = formatMessage(_skuSelectorMessages.skuBinMessages.noFilterResult, {
        filter: filter
      });
      var innerContent = dataExists ? skuCardList : _react.default.createElement("span", {
        className: "selected-sku-bin__content-text"
      }, filterExists ? noFilterResult : formatMessage(_skuSelectorMessages.skuBinMessages.emptyBinPlaceholder));
      var disableRemove = skuInfoList.length === 0;
      var showRemoveModal = this.state.showRemoveModal;
      var getData = generateCsvRowsOverride ? function () {
        return generateCsvRowsOverride(skuInfoList);
      } : function () {
        return skuInfoList.map(function (skuInfo) {
          return [skuInfo.sku];
        });
      };

      var header = showCsvDownload && _react.default.createElement("div", {
        className: "selected-sku-bin__header"
      }, _react.default.createElement("span", null, skuInfoList && skuInfoList.length > 0 && _react.default.createElement(_CsvLinkDownload.default, {
        getData: getData,
        fileName: formatMessage(_skuSelectorMessages.skuBinMessages.csvName),
        linkText: formatMessage(_skuSelectorMessages.skuBinMessages.csvDownloadLink, {
          number: skuInfoList.length
        })
      })));

      var filterBar = showFilter && _react.default.createElement("div", {
        className: "selected-sku-bin__filterbar"
      }, _react.default.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between'
        }
      }, _react.default.createElement(_reactComponents.TextField, {
        style: {
          flexBasis: '250px',
          marginBottom: '0'
        },
        id: "FilterBar",
        type: "search",
        value: filter,
        onChange: this.onChangeFilter,
        label: formatMessage(_skuSelectorMessages.skuBinMessages.filterLabel)
      }), bulkRemoveSkus && _react.default.createElement(_reactComponents.Button, {
        type: "default",
        onClick: this.openRemoveSkusModal,
        disabled: disabled || disableRemove
      }, formatMessage(_skuSelectorMessages.skuBinMessages.removeSkuButtonText))), _react.default.createElement(_LinkDropdown.default, {
        title: formatMessage(_skuSelectorMessages.skuBinMessages.filterTitle),
        style: {
          margin: '12px 0'
        }
      }, _react.default.createElement(_reactComponents.Checkbox, {
        className: "selected-sku-bin__filter-option",
        label: formatMessage(_skuSelectorMessages.skuBinMessages.skuFilter),
        checked: filterBySku,
        onChange: function onChange() {
          return _this2.onChangeFilterOption('filterBySku');
        }
      }), _react.default.createElement(_reactComponents.Checkbox, {
        className: "selected-sku-bin__filter-option",
        label: formatMessage(_skuSelectorMessages.skuBinMessages.descriptionFilter),
        checked: filterByDescription,
        onChange: function onChange() {
          return _this2.onChangeFilterOption('filterByDescription');
        }
      }), _react.default.createElement(_reactComponents.Checkbox, {
        className: "selected-sku-bin__filter-option",
        label: formatMessage(_skuSelectorMessages.skuBinMessages.nameFilter),
        checked: filterByName,
        onChange: function onChange() {
          return _this2.onChangeFilterOption('filterByName');
        }
      })));

      return _react.default.createElement("div", {
        className: "selected-sku-bin ".concat(className || ''),
        style: style
      }, filterBar, showRemoveModal && _react.default.createElement(_SkuUploadModal.default, {
        show: showRemoveModal,
        onClose: this.closeRemoveSkusModal,
        bulkRemoveSkus: bulkRemoveSkus,
        add: false,
        customBulkErrorMessage: customBulkErrorMessage
      }), _react.default.createElement("div", {
        className: contentClassName
      }, innerContent), header);
    }
  }]);
  return SelectedSkuBin;
}(_react.PureComponent);

SelectedSkuBin.defaultProps = {
  showFilter: true,
  showCsvDownload: true,
  customSkuCardVirtualizedListProps: {}
};

var _default = (0, _withI18n.default)((0, _reactIntl.injectIntl)(SelectedSkuBin));

exports.default = _default;